import { useTranslation } from 'react-i18next';
import { SubscriptionStatus } from '~/modules/myAccount/enums';

export default function useSubscriptionStatus() {
  const { t } = useTranslation('app');
  const badges = {
    active: {
      text: t('active'),
      variant: 'success',
    },
    gracePeriod: {
      text: t('expiringSoon'),
      variant: 'warning',
    },
    inActive: {
      text: t('inActive'),
      variant: 'danger',
    },
  };

  const getStatusData = (status: SubscriptionStatus) => {
    let badge: { text: string; variant: string };
    switch (status) {
      case SubscriptionStatus.ACTIVE:
        badge = badges.active;
        break;
      case SubscriptionStatus.GRACE_PERIOD:
        badge = badges.gracePeriod;
        break;
      default:
        badge = badges.inActive;
    }
    return badge;
  };

  return { getStatusData };
}
